import { ComponentProps, FC } from "react";
import { DatePicker } from "@vygruppen/spor-react";

type DatePickerProps = ComponentProps<typeof DatePicker>;
type DropsDatePickerProps = DatePickerProps & {
  withPortal: boolean;
};

export const InternalDropsDatePicker: FC<DropsDatePickerProps> = ({
  ...props
}) => <DatePicker {...props} />;
